import styled from 'styled-components'
import {
  space,
  width,
  fontSize,
  color,
  textAlign,
  display,
  maxWidth,
  minWidth,
  height,
  maxHeight,
  minHeight,
  alignItems,
  alignSelf,
  justifyContent,
  flexWrap,
  flexDirection,
  flex,
  order,
  overflow,
  position,
  zIndex,
  gridGap,
  gridColumnGap,
  gridRowGap,
  gridColumn,
  gridRow,
  gridAutoFlow,
  gridAutoColumns,
  gridAutoRows,
  gridTemplateColumns,
  gridTemplateRows,
  gridTemplateAreas,
  gridArea,
  justifyItems,
} from 'styled-system'

const Box = styled.div(
  [],
  space,
  width,
  fontSize,
  color,
  textAlign,
  display,
  maxWidth,
  minWidth,
  height,
  maxHeight,
  minHeight,
  flex,
  order,
  overflow,
  position,
  zIndex,
  gridArea,
  gridColumn
)

const Flex = styled(Box)`
  display: flex;
  ${alignItems}
  ${justifyContent}
  ${flexWrap}
  ${flexDirection}
  ${display}
  ${alignSelf}
`

const Grid = styled(Box)`
  display: grid;
  ${alignItems}
  ${justifyContent}
  ${gridGap}
  ${gridColumnGap}
  ${gridRowGap}
  ${gridColumn}
  ${gridRow}
  ${gridAutoFlow}
  ${gridAutoColumns}
  ${gridAutoRows}
  ${gridTemplateColumns}
  ${gridTemplateRows}
  ${gridTemplateAreas}
  ${justifyItems}
`

export { Box, Flex, Grid }
